import _List from './list';

import './style/index.js';

export * from './type';

export const List = _List;
export default List;
